"use strict";

import { getAuthContext } from "../config/authConfig.js";
import { getSocialConfig } from "../config/environments/index.js";
import forge from "node-forge";
export async function generateSignedHeaders() {
  const {
    userId,
    privateKeyPem
  } = getAuthContext();
  const {
    SOCIAL_TENANT_ID
  } = getSocialConfig();
  const timestamp = Date.now().toString();
  const message = userId ? `${userId}:${SOCIAL_TENANT_ID}:${timestamp}` : `${SOCIAL_TENANT_ID}:${timestamp}`;
  let signature = "";
  try {
    const forgePrivateKey = forge.pki.privateKeyFromPem(privateKeyPem);
    const md = forge.md.sha256.create();
    md.update(message, "utf8");

    // Build PSS object manually
    const pss = forge.pss.create({
      md: forge.md.sha256.create(),
      mgf: forge.mgf.mgf1.create(forge.md.sha256.create()),
      saltLength: 32
    });
    const rawSignature = forgePrivateKey.sign(md, pss);
    signature = forge.util.encode64(rawSignature);
  } catch (err) {
    console.error("❌ Forge signing failed:", err);
  }
  return {
    "x-user-id": userId,
    "x-auth-timestamp": timestamp,
    "x-auth-signature": signature,
    "x-tenant-id": SOCIAL_TENANT_ID
  };
}
//# sourceMappingURL=generateSignedHeaders.js.map